(function () {
  'use strict';

  var FIRST_PAID_BOX_CODE = 'first_paid_box_paid_changes_locked';
  var FIRST_PAID_BOX_NOTICE = 'Your first box is already paid. You can still swap included meals before the cutoff shown above. Paid upgrades and add-ons can be changed starting with your next weekly box.';
  var addOnMirror = {
    ready: false,
    items: [],
    originalSignature: null
  };

  function eligibleQaCustomer() {
    return /^\d+$/.test(String(window.SW_CUSTOMER_ID || ''));
  }

  function normalizeAddOns(items) {
    return (Array.isArray(items) ? items : []).map(function (item) {
      return {
        variant_id: String(item.variant_id || item.variantId || ''),
        frequency: item.frequency === 'recurring' ? 'recurring' : 'one_time',
        quantity: Math.max(1, Math.min(20, parseInt(item.quantity, 10) || 1))
      };
    }).filter(function (item) {
      return /^\d+$/.test(item.variant_id);
    }).sort(function (a, b) {
      return (a.variant_id + ':' + a.frequency).localeCompare(b.variant_id + ':' + b.frequency);
    });
  }

  function addOnSignature(items) {
    return JSON.stringify(normalizeAddOns(items));
  }

  function seedAddOnMirrorFromServer(items) {
    var normalized = normalizeAddOns(items);
    addOnMirror.items = normalized;
    addOnMirror.originalSignature = addOnSignature(normalized);
    addOnMirror.ready = true;
  }

  function selectedAddOnsFromGrid() {
    var grid = document.getElementById('sw-addon-grid');
    if (!grid) return [];
    var out = [];
    grid.querySelectorAll('.sw-addon-choice.selected').forEach(function (choice) {
      var control = choice.querySelector('button[onclick*="adjustAddOn"]');
      var source = control && control.getAttribute('onclick') || '';
      var match = source.match(/adjustAddOn\(\s*['"](\d+)['"]\s*,\s*['"](recurring|one_time)['"]/);
      if (!match) return;
      var quantityNode = choice.querySelector('.sw-addon-qty strong');
      var quantity = Math.max(1, Math.min(20, parseInt(quantityNode && quantityNode.textContent, 10) || 1));
      out.push({ variant_id: match[1], frequency: match[2], quantity: quantity });
    });
    return normalizeAddOns(out);
  }

  function allExtrasFilterActive() {
    var active = document.querySelector('#sw-addon-filters .sw-addon-filter.active');
    if (!active) return true;
    var source = active.getAttribute('onclick') || '';
    return /setAddOnCategory\(\s*['"]all['"]\s*\)/.test(source)
      || /all extras/i.test(String(active.textContent || ''));
  }

  function captureAddOnMirror(setOriginal) {
    var section = document.getElementById('sw-addon-section');
    var grid = document.getElementById('sw-addon-grid');
    if (!section || !grid || section.hidden || !allExtrasFilterActive()) return false;
    addOnMirror.items = selectedAddOnsFromGrid();
    addOnMirror.ready = true;
    if (setOriginal || addOnMirror.originalSignature === null) {
      addOnMirror.originalSignature = addOnSignature(addOnMirror.items);
    }
    return true;
  }

  function applyAddOnMirrorDelta(variantId, frequency, delta) {
    if (!addOnMirror.ready) return;
    variantId = String(variantId || '');
    frequency = frequency === 'recurring' ? 'recurring' : 'one_time';
    var items = normalizeAddOns(addOnMirror.items);
    var existing = items.find(function (item) {
      return item.variant_id === variantId && item.frequency === frequency;
    });
    if (!existing && delta > 0) {
      items.push({ variant_id: variantId, frequency: frequency, quantity: 1 });
    } else if (existing) {
      var next = Math.max(0, Math.min(20, existing.quantity + Number(delta || 0)));
      if (next === 0) {
        items = items.filter(function (item) {
          return !(item.variant_id === variantId && item.frequency === frequency);
        });
      } else {
        existing.quantity = next;
      }
    }
    addOnMirror.items = normalizeAddOns(items);
  }

  function addOnMirrorChanged() {
    if (!addOnMirror.ready || addOnMirror.originalSignature === null) return false;
    return addOnSignature(addOnMirror.items) !== addOnMirror.originalSignature;
  }

  function installAddOnMirror() {
    var grid = document.getElementById('sw-addon-grid');
    if (!grid) return;

    captureAddOnMirror(true);

    var observer = new MutationObserver(function () {
      window.setTimeout(function () {
        if (allExtrasFilterActive()) captureAddOnMirror(false);
      }, 0);
    });
    observer.observe(grid, { childList: true, subtree: true, characterData: true });

    if (typeof window.adjustAddOn === 'function' && !window.adjustAddOn.__skReturningAddOnBridge) {
      var nativeAdjustAddOn = window.adjustAddOn;
      var wrappedAdjustAddOn = function (variantId, frequency, delta) {
        var result = nativeAdjustAddOn.apply(this, arguments);
        if (allExtrasFilterActive()) captureAddOnMirror(false);
        else applyAddOnMirrorDelta(variantId, frequency, delta);
        return result;
      };
      wrappedAdjustAddOn.__skReturningAddOnBridge = true;
      window.adjustAddOn = wrappedAdjustAddOn;
    }

    if (typeof window.setAddOnCategory === 'function' && !window.setAddOnCategory.__skReturningAddOnBridge) {
      var nativeSetAddOnCategory = window.setAddOnCategory;
      var wrappedSetAddOnCategory = function (category) {
        if (allExtrasFilterActive()) captureAddOnMirror(false);
        var result = nativeSetAddOnCategory.apply(this, arguments);
        if (String(category || 'all') === 'all') captureAddOnMirror(false);
        return result;
      };
      wrappedSetAddOnCategory.__skReturningAddOnBridge = true;
      window.setAddOnCategory = wrappedSetAddOnCategory;
    }
  }

  function qaOperationId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var values;
    try {
      values = new Uint8Array(16);
      window.crypto.getRandomValues(values);
    } catch (e) {
      values = new Uint8Array(16);
      for (var index = 0; index < values.length; index++) values[index] = Math.floor(Math.random() * 256);
    }
    values[6] = (values[6] & 15) | 64;
    values[8] = (values[8] & 63) | 128;
    var hex = Array.from(values).map(function (value) { return value.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-'
      + hex.slice(16, 20) + '-' + hex.slice(20);
  }

  function canonicalWeeklyWriteSignature(payload) {
    var items = (Array.isArray(payload.items) ? payload.items : []).map(function (item) {
      return { variant_id: String(item.variant_id || ''), quantity: Number(item.quantity || 0) };
    }).sort(function (a, b) { return a.variant_id.localeCompare(b.variant_id); });
    return JSON.stringify({
      delivery_week_start: String(payload.delivery_week_start || ''),
      items: items,
      add_ons: normalizeAddOns(payload.add_ons || [])
    });
  }

  function stableOperationId(signature) {
    var key = 'sk_returning_weekly_operation';
    try {
      var stored = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (stored && stored.signature === signature && typeof stored.id === 'string') return stored.id;
    } catch (e) {}
    var id = qaOperationId();
    try { sessionStorage.setItem(key, JSON.stringify({ signature: signature, id: id })); } catch (e) {}
    return id;
  }

  function clearStableOperation(signature) {
    var key = 'sk_returning_weekly_operation';
    try {
      var stored = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (stored && stored.signature === signature) sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function prepareWeeklyWrite(url, init) {
    var result = { init: init, addOnChanged: false, signature: null };
    if (!init || String(init.method || 'GET').toUpperCase() !== 'POST') return result;
    if (String(url || '').indexOf('/weekly-selection') === -1) return result;
    if (!addOnMirrorChanged()) return result;

    var payload;
    try { payload = JSON.parse(init.body || '{}'); } catch (e) { return result; }
    if (!payload || typeof payload !== 'object' || !Array.isArray(payload.items)) return result;

    payload.add_ons = normalizeAddOns(addOnMirror.items);
    var signature = canonicalWeeklyWriteSignature(payload);
    payload.operation_id = payload.operation_id || stableOperationId(signature);
    result.init = Object.assign({}, init, { body: JSON.stringify(payload) });
    result.addOnChanged = true;
    result.signature = signature;

    ['sb-confirm-btn', 'sw-top-confirm', 'sw-sheet-confirm'].forEach(function (id) {
      var button = document.getElementById(id);
      if (button) button.textContent = 'Updating Your Weekly Selections…';
    });
    return result;
  }

  function markAddOnWriteSuccess(meta) {
    if (!meta || !meta.addOnChanged) return;
    addOnMirror.items = normalizeAddOns(addOnMirror.items);
    addOnMirror.originalSignature = addOnSignature(addOnMirror.items);
    clearStableOperation(meta.signature);
    window.__skReturningAddOnSaveSucceeded = true;
  }

  function showPaidFirstBoxNotice() {
    var notice = document.getElementById('sw-cycle-notice');
    if (!notice) return;
    notice.textContent = FIRST_PAID_BOX_NOTICE;
    notice.classList.add('show');
    notice.setAttribute('role', 'alert');
    notice.setAttribute('aria-live', 'polite');
  }

  function ensurePaidFirstBoxModal() {
    var existing = document.getElementById('sw-first-paid-box-modal');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.id = 'sw-first-paid-box-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'sw-first-paid-box-title');
    overlay.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'z-index:9999',
      'background:rgba(0,0,0,.62)',
      'padding:24px',
      'align-items:center',
      'justify-content:center'
    ].join(';');

    overlay.innerHTML = ''
      + '<div style="width:min(520px,100%);background:#fff;border-radius:22px;padding:28px 26px;box-shadow:0 24px 80px rgba(0,0,0,.35);text-align:center;font-family:DM Sans,Arial,sans-serif;">'
      +   '<div style="width:52px;height:52px;margin:0 auto 16px;border-radius:50%;background:#fff1e8;color:#b85c2a;display:flex;align-items:center;justify-content:center;font-size:26px;font-weight:800;">!</div>'
      +   '<h2 id="sw-first-paid-box-title" style="margin:0 0 10px;font-family:Playfair Display,Georgia,serif;font-size:28px;line-height:1.15;color:#1c1c1c;">Your first box is already paid</h2>'
      +   '<p style="margin:0 auto 12px;max-width:430px;font-size:16px;line-height:1.55;color:#4a4a4a;">You can still swap included meals before the cutoff. Paid upgrades and add-ons for this first box are locked because checkout has already been charged.</p>'
      +   '<p style="margin:0 auto 22px;max-width:430px;font-size:15px;line-height:1.5;color:#6b6b6b;">You can change paid upgrades and add-ons starting with your next weekly box. Nothing was changed or charged from this attempt.</p>'
      +   '<button type="button" id="sw-first-paid-box-close" style="width:100%;border:0;border-radius:999px;background:#b85c2a;color:#fff;padding:14px 20px;font:700 16px DM Sans,Arial,sans-serif;cursor:pointer;">Got it</button>'
      + '</div>';

    document.body.appendChild(overlay);
    var close = document.getElementById('sw-first-paid-box-close');
    if (close) close.addEventListener('click', hidePaidFirstBoxModal);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) hidePaidFirstBoxModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.style.display === 'flex') hidePaidFirstBoxModal();
    });
    return overlay;
  }

  function showPaidFirstBoxModal() {
    var modal = ensurePaidFirstBoxModal();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () {
      var close = document.getElementById('sw-first-paid-box-close');
      if (close) close.focus();
    }, 0);
  }

  function hidePaidFirstBoxModal() {
    var modal = document.getElementById('sw-first-paid-box-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function captureKnownWeeklyError(response, url) {
    if (!response || response.ok || String(url || '').indexOf('/weekly-selection') === -1) {
      return Promise.resolve(response);
    }
    return response.clone().json().catch(function () { return null; }).then(function (data) {
      if (data && data.code === FIRST_PAID_BOX_CODE) {
        window.__skPhase2KnownWeeklyError = { code: FIRST_PAID_BOX_CODE };
        showPaidFirstBoxNotice();
      }
      return response;
    });
  }

  function installProductionReadBridge() {
    if (window.__skPhase2ProductionReadBridge || typeof window.fetch !== 'function') return;
    var nativeFetch = window.fetch.bind(window);
    window.__skPhase2ProductionReadBridge = true;

    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      if (!eligibleQaCustomer()) return nativeFetch(input, init);

      var qaWeeklyPath = '/apps/smoketo-sub/phase2-qa-weekly-selection';
      var isQaWeekly = url.indexOf(qaWeeklyPath) !== -1;
      var effectiveUrl = isQaWeekly ? url.replace('/phase2-qa-weekly-selection', '/weekly-selection') : url;
      var writeMeta = prepareWeeklyWrite(effectiveUrl, init);
      var effectiveInit = writeMeta.init;
      var request = isQaWeekly ? nativeFetch(effectiveUrl, effectiveInit) : nativeFetch(input, effectiveInit);

      return request.then(function (response) {
        return captureKnownWeeklyError(response, effectiveUrl).then(function (checkedResponse) {
          if (writeMeta.addOnChanged && checkedResponse.ok) markAddOnWriteSuccess(writeMeta);
          if (!isQaWeekly || !checkedResponse.ok) return checkedResponse;
          return checkedResponse.clone().json().then(function (data) {
            if (Array.isArray(data.addOns)) seedAddOnMirrorFromServer(data.addOns);
            data.environment = 'phase2_qa';
            data.qaReadOnly = false;
            data.subscription = {
              status: 'ACTIVE',
              provider: 'appstle',
              verification: 'production_returning_api',
              plan_size: Number(data.subscriptionSize || 0)
            };
            var headers = new Headers(checkedResponse.headers);
            headers.set('content-type', 'application/json');
            return new Response(JSON.stringify(data), {
              status: checkedResponse.status,
              statusText: checkedResponse.statusText,
              headers: headers
            });
          });
        });
      });
    };
  }

  function installKnownErrorToast() {
    var toast = document.getElementById('sw-toast');
    if (!toast) return;
    var observer = new MutationObserver(function () {
      var known = window.__skPhase2KnownWeeklyError;
      if (!known || known.code !== FIRST_PAID_BOX_CODE) return;
      if (String(toast.textContent || '').indexOf('Could not update your box') === -1) return;
      toast.classList.remove('show');
      showPaidFirstBoxNotice();
      showPaidFirstBoxModal();
      window.__skPhase2KnownWeeklyError = null;
    });
    observer.observe(toast, { childList: true, characterData: true, subtree: true });
  }

  function installAddOnSuccessExperience() {
    var note = document.querySelector('.sw-addon-pending');
    if (note) {
      note.textContent = 'Changes are saved only when you tap Update My Meals. “Every week” repeats until you remove it; “This week” applies only to the upcoming box.';
    }

    if (typeof window.closeSubscriberCompletion === 'function' && !window.closeSubscriberCompletion.__skReturningAddOnBridge) {
      var nativeClose = window.closeSubscriberCompletion;
      var wrappedClose = function () {
        var shouldReload = window.__skReturningAddOnSaveSucceeded === true;
        var result = nativeClose.apply(this, arguments);
        if (shouldReload) {
          window.__skReturningAddOnSaveSucceeded = false;
          window.setTimeout(function () { window.location.reload(); }, 40);
        }
        return result;
      };
      wrappedClose.__skReturningAddOnBridge = true;
      window.closeSubscriberCompletion = wrappedClose;
    }

    var modal = document.getElementById('sw-complete-modal');
    if (modal) {
      var completionObserver = new MutationObserver(function () {
        if (!window.__skReturningAddOnSaveSucceeded || !modal.classList.contains('open')) return;
        var title = document.getElementById('sw-complete-title');
        var copy = document.getElementById('sw-complete-copy');
        if (title) title.textContent = 'Your weekly selections are updated!';
        if (copy) {
          copy.textContent = String(copy.textContent || '').replace(/^Your \d+ meals are set/, 'Your meals and add-ons are set');
        }
      });
      completionObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function setGuidance() {
    var selected = document.getElementById('sw-sel-count');
    var plan = document.getElementById('sw-plan-size');
    var bar = document.querySelector('.sw-counter-inner');
    if (!selected || !plan || !bar) return;

    var selectedCount = parseInt(selected.textContent, 10) || 0;
    var planCount = parseInt(plan.textContent, 10) || 0;
    var remaining = Math.max(0, planCount - selectedCount);
    var guidance = document.getElementById('sw-qa-plan-guidance');
    if (!guidance) {
      guidance = document.createElement('span');
      guidance.id = 'sw-qa-plan-guidance';
      guidance.setAttribute('role', 'status');
      guidance.setAttribute('aria-live', 'polite');
      guidance.style.cssText = 'font-size:.76rem;font-weight:700;color:#7a6559;white-space:nowrap;';
      bar.insertBefore(guidance, document.getElementById('sw-top-confirm'));
    }

    if (!planCount) guidance.textContent = '';
    else if (remaining > 0) guidance.textContent = 'You’re on the ' + planCount + '-meal plan — choose ' + remaining + ' more.';
    else guidance.textContent = 'Your ' + planCount + '-meal plan is complete.';

    var topButton = document.getElementById('sw-top-confirm');
    if (topButton) {
      topButton.classList.add('show');
      topButton.disabled = selectedCount !== planCount;
    }
  }

  function enableQaWrite() {
    if (!eligibleQaCustomer()) return;
    if (window.SW_PHASE2_QA_READ_ONLY !== true) return;

    window.SW_PHASE2_QA_READ_ONLY = false;
    document.documentElement.setAttribute('data-smoketo-returning-write-qa', 'enabled');

    var notice = document.getElementById('sw-cycle-notice');
    if (notice) {
      notice.textContent = 'Subscriber QA: this preview reads and saves weekly selections through the production returning-subscriber API. The server verifies the signed-in customer and active subscription before saving.';
      notice.classList.add('show');
    }
  }

  function installCounterObserver() {
    var selected = document.getElementById('sw-sel-count');
    var plan = document.getElementById('sw-plan-size');
    if (!selected || !plan) return;
    var observer = new MutationObserver(setGuidance);
    observer.observe(selected, { childList: true, characterData: true, subtree: true });
    observer.observe(plan, { childList: true, characterData: true, subtree: true });
    setGuidance();
  }

  function run() {
    if (!/\/pages\/subscribe\/?$/.test(window.location.pathname)) return;
    enableQaWrite();
    ensurePaidFirstBoxModal();
    installKnownErrorToast();
    installCounterObserver();
    installAddOnMirror();
    installAddOnSuccessExperience();
  }

  installProductionReadBridge();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
